export default function getEventItemInfo(event) {
  const backgroundColorStyle = event.base_color ? `background-color: ${event.base_color}` : ''
  const ringColorStyle = event.ring_color ? `--un-ring-color: ${event.ring_color}` : ''

  const eventHasWaitlist = !event.isEnded && !event.is_appointment && event.waitlist_max !== 0

  return {
    backgroundColorStyle,
    ringColorStyle,
    eventHasWaitlist,
  }
}
